import React from "react";
import { Form } from "formik";
import PropTypes from "prop-types";

import { useViewport, ViewportType } from "utils/ViewportContext";
import DesktopSearchForm from "./DesktopSearchForm";
import MobileSearchForm from "./MobileSearchForm";
import CustomFormik from "common/basicComponents/CustomFormik";

const LinkSearch = ({ onSearch }) => {
  const { type: viewportType } = useViewport();

  const onSubmit = (values, { setSubmitting }) => {
    setSubmitting(true);
    onSearch({
      linkSearch: values.linkSearch,
      productId: values.product.value || null,
    });
    setSubmitting(false);
  };

  return (
    <CustomFormik
      initialValues={{
        linkSearch: "",
        product: { label: "", value: "" },
      }}
      onSubmit={onSubmit}
      countChangedFields
    >
      <Form>
        {viewportType === ViewportType.DESKTOP ? (
          <DesktopSearchForm />
        ) : (
          <MobileSearchForm />
        )}
      </Form>
    </CustomFormik>
  );
};

LinkSearch.propTypes = {
  onSearch: PropTypes.func.isRequired,
};

export default LinkSearch;
